import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function BeforeAfterSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-18">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-19">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-12 text-center uppercase" data-id="element-20">
          Lo que cambia cuando lo aplicás
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-21">
          {/* Antes */}
          <div className="bg-zinc-900/50 border border-red-900/30 rounded-2xl p-8 relative overflow-hidden" data-id="element-22">
            <div className="absolute top-0 left-0 w-full h-1 bg-red-500/50" data-id="element-23" />
            <h3 className="text-2xl font-heading font-bold text-zinc-400 mb-6 uppercase flex items-center gap-2" data-id="element-24">
              <XCircle className="text-red-500" data-id="element-25" /> Antes:
            </h3>
            <ul className="space-y-4" data-id="element-26">
              <li className="text-lg text-zinc-300 flex items-center gap-3" data-id="element-27">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500/50" data-id="element-28" />{' '}
                Martes muerto.
              </li>
              <li className="text-lg text-zinc-300 flex items-center gap-3" data-id="element-29">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500/50" data-id="element-30" />{' '}
                Sábado agotador.
              </li>
              <li className="text-lg text-zinc-300 flex items-center gap-3" data-id="element-31">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500/50" data-id="element-32" />{' '}
                Ingreso impredecible.
              </li>
              <li className="text-lg text-zinc-300 flex items-center gap-3" data-id="element-33">
                <span className="w-1.5 h-1.5 rounded-full bg-red-500/50" data-id="element-34" />{' '}
                Cansancio constante.
              </li>
            </ul>
          </div>

          {/* Después */}
          <div className="bg-zinc-900 border border-amber-500/30 rounded-2xl p-8 relative overflow-hidden shadow-[0_0_30px_rgba(245,158,11,0.1)]" data-id="element-35">
            <div className="absolute top-0 left-0 w-full h-1 bg-amber-500" data-id="element-36" />
            <h3 className="text-2xl font-heading font-bold text-amber-400 mb-6 uppercase flex items-center gap-2" data-id="element-37">
              <CheckCircle2 className="text-amber-500" data-id="element-38" /> Después:
            </h3>
            <ul className="space-y-4" data-id="element-39">
              <li className="text-lg text-white font-medium flex items-center gap-3" data-id="element-40">
                <span className="w-2 h-2 rounded-full bg-amber-500" data-id="element-41" /> Semana
                más pareja.
              </li>
              <li className="text-lg text-white font-medium flex items-center gap-3" data-id="element-42">
                <span className="w-2 h-2 rounded-full bg-amber-500" data-id="element-43" /> Sábado
                controlado.
              </li>
              <li className="text-lg text-white font-medium flex items-center gap-3" data-id="element-44">
                <span className="w-2 h-2 rounded-full bg-amber-500" data-id="element-45" /> Más plata
                por cliente.
              </li>
              <li className="text-lg text-white font-medium flex items-center gap-3" data-id="element-46">
                <span className="w-2 h-2 rounded-full bg-amber-500" data-id="element-47" /> Más
                tranquilidad mental.
              </li>
            </ul>
          </div>
        </div>
      </motion.div>
    </section>;
}